import BookingDetails from '@components/BookingDetails/BookingDetails';
import {
  InnerContainer,
  RightContainer,
  StepContainer,
} from '@components/Steps/Steps.styles';
import { LuxTypography, Stack, useTheme } from '@gemini/fe-ds-core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePatientStore } from '@store/patientStore';
import CalendarPage, {
  CalendarProps,
} from '@components/CalendarPage/CalendarPage';
import { RescheduleWrapper } from './RescheduleFlow.styles';
import { useOnlineBookingStore } from '@store/onlineBookingStore';

const RescheduleScheduleExamPage = ({ setEnableButton }: CalendarProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const brandName = useOnlineBookingStore(state => state.brandName);

  const patients = usePatientStore(state => state.patients);
  const previousSlotToDisable = useMemo(
    () => ({
      day:
        patients[0]?.previousSlotToDisable?.day instanceof Date
          ? patients[0].previousSlotToDisable.day.toISOString().split('T')[0]
          : patients[0]?.previousSlotToDisable?.day || '',
      hour: patients[0]?.previousSlotToDisable?.hour || '',
      doctor: patients[0]?.previousSlotToDisable?.doctor || '',
    }),
    [patients],
  );

  return (
    <>
      {!brandName && (
        <Stack
          style={{
            width: '100%',
            padding: '0.5rem 1rem',
            backgroundColor: 'white',
          }}
          justifyContent="center"
          alignItems="flex-start"
        >
          <LuxTypography variant="heading3">{t('bookingTitle')}</LuxTypography>
        </Stack>
      )}
      <RescheduleWrapper>
        <InnerContainer>
          <StepContainer
            borderColor={
              theme.palette.LUX.obTokens?.bordersColorNeutralSecondary
            }
            noStyle
          >
            <CalendarPage
              setEnableButton={setEnableButton}
              previousSlotToDisable={previousSlotToDisable}
            />
          </StepContainer>
          <RightContainer manageOrRescheduleMode>
            <BookingDetails hideEditButton manageOrRescheduleMode />
          </RightContainer>
        </InnerContainer>
      </RescheduleWrapper>
    </>
  );
};

export default RescheduleScheduleExamPage;
